import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Wizard from "@/pages/Wizard";
import CapsuleDetail from "@/pages/CapsuleDetail";
import HowItWorks from "@/pages/HowItWorks";
import Pricing from "@/pages/Pricing";
import FAQ from "@/pages/FAQ";
import Security from "@/pages/Security";
import Profile from "@/pages/Profile";
import AdminAgreements from "@/pages/AdminAgreements";
import AdminUsers from "./pages/AdminUsers";
import { CookieBanner, CookiePrefsButton } from "./components/CookieBanner";
import { InstallAppButton } from "./components/InstallAppButton";
import AdminConsent from "@/pages/AdminConsent";
import AdminPayments from "@/pages/AdminPayments";
import VoucherSuccess from "@/pages/VoucherSuccess";
import VoucherCancel from "@/pages/VoucherCancel";
import VoucherVerify from "@/pages/VoucherVerify";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import InviteAccept from "@/pages/InviteAccept";
import OpenByLink from "@/pages/OpenByLink";
import AnchorVerify from "@/pages/AnchorVerify";
import Bacheca from "@/pages/Bacheca";
import MiabExplore from "@/pages/MiabExplore";
import MiabCreate from "@/pages/MiabCreate";
import RaccontiCatalog from "@/pages/RaccontiCatalog";
import RaccontiAuthorRegister from "@/pages/RaccontiAuthorRegister";
import RaccontiAuthorDashboard from "@/pages/RaccontiAuthorDashboard";
import RaccontiAuthorPage from "@/pages/RaccontiAuthorPage";
import ProtectedRoute from "@/components/ProtectedRoute";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading || user === null) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Landing />;
}

function App() {
  return (
    <AuthProvider>
      <div className="fixed bottom-4 left-4 z-[60] flex items-center gap-2" data-testid="language-switcher-wrap"><LanguageSwitcher /><CookiePrefsButton /><InstallAppButton /></div>
      <CookieBanner />
      <BrowserRouter>
        <Toaster theme="dark" position="top-center" toastOptions={{
          style: { background: "#0F1A2E", border: "1px solid rgba(255,255,255,0.12)", color: "#F8F5F0" }
        }} />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/come-funziona" element={<HowItWorks />} />
          <Route path="/prezzi" element={<Pricing />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/sicurezza" element={<Security />} />
          <Route path="/verifica-voucher/:public_id" element={<VoucherVerify />} />
          <Route path="/verifica-sigillo/:anchor_id" element={<AnchorVerify />} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/invito/:invitation_id" element={<InviteAccept />} />
          <Route path="/apri/:token" element={<OpenByLink />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/profilo" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/admin/convenzioni" element={<ProtectedRoute><AdminAgreements /></ProtectedRoute>} />
          <Route path="/admin/consensi" element={<ProtectedRoute><AdminConsent /></ProtectedRoute>} />
          <Route path="/admin/utenti" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/pagamenti" element={<ProtectedRoute><AdminPayments /></ProtectedRoute>} />
          <Route path="/wizard" element={<ProtectedRoute><Wizard /></ProtectedRoute>} />
          <Route path="/wizard/:id" element={<ProtectedRoute><Wizard /></ProtectedRoute>} />
          <Route path="/capsule/:id" element={<ProtectedRoute><CapsuleDetail /></ProtectedRoute>} />
          <Route path="/bacheca" element={<ProtectedRoute><Bacheca /></ProtectedRoute>} />
          <Route path="/miab" element={<ProtectedRoute><MiabExplore /></ProtectedRoute>} />
          <Route path="/miab/nuovo" element={<ProtectedRoute><MiabCreate /></ProtectedRoute>} />
          <Route path="/racconti" element={<ProtectedRoute><RaccontiCatalog /></ProtectedRoute>} />
          <Route path="/racconti/autore/registrati" element={<ProtectedRoute><RaccontiAuthorRegister /></ProtectedRoute>} />
          <Route path="/racconti/dashboard" element={<ProtectedRoute><RaccontiAuthorDashboard /></ProtectedRoute>} />
          <Route path="/racconti/autore/:slug" element={<ProtectedRoute><RaccontiAuthorPage /></ProtectedRoute>} />
          <Route path="/voucher-success" element={<ProtectedRoute><VoucherSuccess /></ProtectedRoute>} />
          <Route path="/voucher-cancel" element={<ProtectedRoute><VoucherCancel /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
